import styled, { keyframes, css } from "styled-components";

const recordPulse = keyframes`
  0%, 100% { transform: scale(1); box-shadow: 0 0 14px var(--warn); }
  50%      { transform: scale(1.05); box-shadow: 0 0 28px var(--warn); }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 100%;
  max-width: 520px;
  padding: 0 24px;
`;

export const Title = styled.div`
  font-family: 'JetBrains Mono', monospace;
  font-size: 56px;
  color: var(--danger);
  letter-spacing: 6px;
  font-weight: 800;
  text-transform: uppercase;
  text-shadow: 0 0 30px var(--danger-glow);
  text-align: center;
`;

export const RecordBadge = styled.div`
  padding: 8px 16px;
  background: var(--panel);
  border: 1px solid var(--warn);
  border-radius: 10px;
  color: var(--warn);
  font-family: 'JetBrains Mono', monospace;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 4px;
  text-transform: uppercase;
  animation: ${recordPulse} 1.4s ease-in-out infinite;
`;

export const Stats = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const StatRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 10px;
  color: var(--text-dim);
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  letter-spacing: 3px;
  text-transform: uppercase;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);

  strong {
    color: var(--accent);
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 1px;
    text-shadow: 0 0 12px var(--accent-glow);
  }

  ${(p) =>
    p.$primary &&
    css`
      padding: 22px 26px;
      strong {
        font-size: 32px;
      }
    `}
`;

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
`;

export const StatBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 14px 10px;
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 10px;
  color: var(--text-dim);
  font-family: 'JetBrains Mono', monospace;
  font-size: 9px;
  letter-spacing: 2px;
  text-transform: uppercase;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);

  strong {
    color: var(--text);
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  gap: 14px;
  margin-top: 8px;
`;

export const PrimaryButton = styled.button`
  border-radius: 12px;
  border: 1px solid var(--accent);
  background: linear-gradient(180deg, rgba(94, 234, 212, 0.18), rgba(94, 234, 212, 0.05));
  color: var(--accent);
  font-family: 'Space Grotesk', sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  padding: 14px 32px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 0 16px var(--accent-glow);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px var(--accent-glow);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const SecondaryButton = styled(PrimaryButton)`
  background: var(--panel);
  border: 1px solid var(--border);
  color: var(--text-dim);
  box-shadow: none;

  &:hover {
    border-color: var(--text-dim);
    color: var(--text);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.4);
  }
`;
